import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { PopupInterface } from 'common/types/entities/popup-interface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Globe03Icon } from 'src/editor/shared/icons/globe-03-icon'
import { Settings02Icon } from 'src/editor/shared/icons/settings-02-icon'
import { Trash02Icon } from 'src/editor/shared/icons/trash-02-icon'
import {
  ButtonSizeEnum,
  GrayIconButton,
} from 'src/editor/shared/ui-lib/buttons'

export interface PopupItemProps {
  entity: PopupInterface
  title: string
  onToggleDisplay: (id: string, showSettings?: boolean) => void
  onRemove: (id: string) => void
  withoutWebsiteGlobal?: boolean
}

export const PopupItem = ({
  entity,
  title,
  onToggleDisplay,
  onRemove,
  withoutWebsiteGlobal,
}: PopupItemProps) => {
  const updateEntity = useUpdateEntity()
  const { t } = useTranslation()
  const onWebsiteGlobalToggle = () => {
    const { isWebsiteGlobal, ...rest } = entity
    if (isWebsiteGlobal) {
      updateEntity({ ...rest })
    } else {
      updateEntity({ ...rest, isWebsiteGlobal: true })
    }
  }
  return (
    <div className="flex justify-between rounded-md bg-bgSecondary text-M">
      <button
        type="button"
        onClick={() => onToggleDisplay(entity.id)}
        className="flex flex-1 cursor-pointer items-center p-1.5"
      >
        <span className="max-w-[190px] overflow-hidden text-ellipsis whitespace-nowrap break-all">
          {title}
        </span>
      </button>
      <div className="flex items-center p-1.5">
        {!withoutWebsiteGlobal && (
          <GrayIconButton
            size={ButtonSizeEnum.Small}
            icon={
              <Globe03Icon
                title={t('popup_management.toggle_global_button.title')}
                className={`[&>path]:stroke-none! ${entity.isWebsiteGlobal ? '[&>path]:fill-iconPrimary' : '[&>path]:fill-iconSecondary'}`}
              />
            }
            onClick={onWebsiteGlobalToggle}
            title={t('popup_management.toggle_global_button.title')}
          />
        )}
        <GrayIconButton
          size={ButtonSizeEnum.Small}
          icon={
            <Settings02Icon
              title={t('popup_management.settings_button.title')}
            />
          }
          onClick={() => onToggleDisplay(entity.id, true)}
          title={t('popup_management.settings_button.title')}
          className="[&>svg>path]:fill-iconSecondary [&>svg>path]:stroke-none disabled:[&>svg>path]:fill-iconDisabled disabled:[&>svg>path]:stroke-none"
        />
        <GrayIconButton
          size={ButtonSizeEnum.Small}
          icon={
            <Trash02Icon
              title={t('popup_management.remove_button.title')}
              className="text-textPrimary"
            />
          }
          onClick={() => onRemove(entity.id)}
          title={t('popup_management.remove_button.title')}
        />
      </div>
    </div>
  )
}
